import envHelper from '../env-helper';

const envObj=envHelper.setEnvironmentURLs();

export const SERVER = {
    API_BASE_URL: envObj.API_BASE_URL,
    loginUrl: envObj.LOGIN_URL,

    SERVICES: {
        //Trustbuilder url
        logoutUrl: envObj.API_LOGOUT_URL,
        redirectUrl : envObj.REDIRECT_URL,
        passwordrResetUrl : envObj.PASSWORD_RESET_URL,

        //Auth url
        validateToken: "/v1/Authorization/oidc/ValidateToken",
        token: "/v1/Authorization/oidc/Token",
        userClaims: "/v1/Authorization/oidc/UserClaims",
        refreshToken: "/v1/Authorization/oidc/RefreshToken",

        //Businesspartner url
        getRevenueDetails: "/v1/BusinessPartners/RevenueDetails",
        submitRevenueDetails: "/v1/BusinessPartners/RevenueDetails",
        importRevenueDetails: "/v1/BusinessPartners/BusinessPartnerDetails",
        exportRevenueDetails: "/v1/BusinessPartners/BusinessPartnerDetails",
        getStatuswiseRevenueDates: "/v1/BusinessPartners/StatuswiseRevenueDates",
        getMonthlyIntakeBookDetails: "/v1/BusinessPartners/MonthlyIntakeBookDetails",
        submitSelectedRevenueDetails: "/v1/BusinessPartners/RevenueDetailsSubmitAll",
        submitSelectedDailyIntakeDetails : "/v1/BusinessPartners/BulkUploadIntakeBook",
        getWeeklyRevenueDetails: "/v1/BusinessPartners/WeeklyRevenueDetails",
        exportWeeklyRevenueDetails: "/v1/BusinessPartners/WeeklyBusinessPartnerDetails",
        importWeeklyRevenueDetails: "/v1/BusinessPartners/WeeklyBusinessPartnerDetails",
        getHelpVideoUrl:"/v1/BusinessPartners/GetHelpVideoUrl",
        UserELearningSubmit :"v1/UserActivity/UserELearningSubmit",
        //Common api url
        getLabelsTranslation: "/v1/LanguageConfig/LabelTranslation",
        getConfig: "/v1/RevenueDateConfig/Config",
        getRemarkOptions: "/v1/RevenueDateConfig/CodeValueDetails",

        //Nmbsusers url
        getOverview: "/v1/NmbsUsers/Overview",
        getOverviewDetails: "/v1/NmbsUsers/OverviewDetails",
        updateOverviewDetails: "/v1/NmbsUsers/OverviewDetails",
        exportOverviewDetails: "/v1/NmbsUsers/RevenueDetails",
        uploadCashRegisterFile: "/v1/NmbsUsers/CashRegisterFile",
        downloadCashRegisterFile: "/v1/NmbsUsers/CashRegisterFile",
        exportAuditDetails: "/v1/NmbsUsers/AuditDetails",

        //Intake book url
        downloadIntakeBookFile: "/v1/MonthlyIntakeBook/Download",

        //Change Request url
        submitChangeRequest: "/v1/ChangeRequest/RevenueDetails",        
        getChangeRequestOverviewDetails: "/v1/ChangeRequest/OverviewDetails",
        getChangeRequestBPOverviewDetails: "/v1/ChangeRequest/BusinessPartnerOverviewDetails",
        submitUnblockRequest: "/v1/ChangeRequest/Unblock",
        getUnblockCrStatus: "/v1/ChangeRequest/ApprovedUnblockCrDetails",
        getPendingCrStatus: "/v1/ChangeRequest/PendingCrCountDetails",
        
        //Reports
        getReportDetails: "/v1/Report/AppUsagePercentage"
    }
}
